import { camelCase } from "lodash-es";

const INVEST_GOAL_SELECT_AMOUNT = {
  dataAid: "selectAmount",
  header: {
    dataAid: (dataAid = "") => camelCase(`saveFor ${dataAid}`),
  },
  heading: {
    dataAid: "title",
    label: "Select the amount you want to save",
  },
};

export default INVEST_GOAL_SELECT_AMOUNT;
